/**
 * Identity in admin QA («Кто правил») for model rewrites of attraction copy.
 * Not an admin login and not counted in moderator payroll.
 */
export const AI_CONTENT_ACTOR_EMAIL = 'ai@routellers.com';
